
namespace RioERP.Orders {
    export class OrdershippingPendrivesColumns {
        static columnsKey = 'Orders.OrdershippingPendrives';
    }
}